import React from 'react';
import LoginButton from '../../components/authentication/LoginButton';

const PageInloggen: React.FC = () => (
  <>
    <header className="app-header">
      <h1>Inloggen</h1>
      <p className="header-sub-title">Log in met uw account en start met plannen.</p>
    </header>

    <div className="content">
      <LoginButton />
    </div>
  </>
);

export default PageInloggen;